import React from 'react';
import { Action, PageBody, PageHead } from '../../components/aa';
import { RegistryPanel, useRegistryEyebrow } from './RegistryPanel';

/*
 * The full Use Case Registry. Home shows the first rows and routes here; this
 * page carries the whole inventory, the discovery banner and shadow AI capture.
 */

const ChampionRegistryPage: React.FC = () => (
  <PageBody>
    <PageHead
      align="center"
      eyebrow={useRegistryEyebrow()}
      title="Use Case Registry"
      sub="Every approved use case, every shadow AI capture and every blocked classification, read through the lens that fits you."
      actions={<Action arrow to="/vendors">Vendor evaluations</Action>}
    />
    <RegistryPanel />
  </PageBody>
);

export default ChampionRegistryPage;
